import React, { useEffect, useRef, useState } from "react";

import "./BybGuides.css";
// import guideone from "../../assets/images/guideone.jpg"
// import guidetwo from "../../assets/images/guidetwo.jpg"
// import guidethree from "../../assets/images/guidethree.jpg"
function BybGuides() {

  
  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);
  return (
    <>
      <section className="bybguides"> 
        <div className="container">
          <div className="bybguides-header">
          <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
              >IN KIT</p>
            <h1>Brand Brewing Guides</h1>
          
          </div>

          <div className="bybguides-maincard">
<div className="bybguides-card-one">
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/bsg.svg" alt="Brand Strategy Guide cover" />
<p className="p-one">BRAND STRATEGY GUIDE</p>
<p className="p-two">Take Your Idea From Vision to Actionable Strategy</p>
<p className="p-three">Craft a roadmap that turns your brand purpose into tangible results.</p>
</div>

<div className="bybguides-card-two">
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/vig.svg" alt="Visual Identity Guide cover" />
<p className="p-one">VISUAL IDENTITY GUIDE</p>
<p className="p-two">Tell a Visual Story That Speaks Volumes</p>
<p className="p-three">Create an authentic look that communicates your brand's soul.</p>
</div>

<div className="bybguides-card-three">
<img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/bbw.svg" alt="Brand Brewing Workbook cover" />
<p  className="p-one"> BRAND BREWING WORKBOOK</p>
<p className="p-two">Measure Today to Raise the Bar Tomorrow</p>
<p className="p-three">Evaluate your brand's current state to inform its future growth.</p>
</div>
          </div>
          
        </div>
      </section>
    </>
  );
}

export default BybGuides;
